import { createRouter, createWebHistory } from "vue-router";
import LoginPage from "../views/LoginPage";
import MainPage from "../views/MainPage";
import LeadsPage from "../views/leads/LeadsPage.vue";
import CreateEditLeadsPage from "../views/leads/CreateEditPage.vue";
import CounterpartiesPage from "../views/counterparties/CounterpartiesPage.vue";
import CreateEditCounterpartiesPage from "../views/counterparties/CreateEditPage.vue";
import ProjectsPage from "../views/projects/ProjectsPage.vue";
import CreateEditProjectsPage from "../views/projects/CreateEditPage.vue";
import EventsPage from "../views/events/EventsPage.vue";
import CreateEditEventsPage from "../views/events/CreateEditPage.vue";
import store from "../store";

const ifNotAuthenticated = (to, from, next) => {
  if (!store.state.auth.token || store.state.auth.token === "undefined") {
    next();
    return;
  }
  next("/");
};

const ifAuthenticated = (to, from, next) => {
  if (store.state.auth.token && store.state.auth.token !== "undefined") {
    next();
    return;
  }
  next("/login");
};

const routes = [
  { path: "/login", component: LoginPage, beforeEnter: ifNotAuthenticated },
  { path: "/", component: MainPage, beforeEnter: ifAuthenticated },
  { path: "/leads", component: LeadsPage, beforeEnter: ifAuthenticated },
  {
    path: "/new-lead",
    component: CreateEditLeadsPage,
    beforeEnter: ifAuthenticated,
    name: "create-lead",
  },
  {
    path: "/lead/:id",
    component: CreateEditLeadsPage,
    beforeEnter: ifAuthenticated,
    name: "edit-lead",
  },
  {
    path: "/counterparties",
    component: CounterpartiesPage,
    beforeEnter: ifAuthenticated,
  },
  {
    path: "/new-counterpartie",
    component: CreateEditCounterpartiesPage,
    beforeEnter: ifAuthenticated,
    name: "create-counterpartie",
  },
  {
    path: "/counterpartie/:slug",
    component: CreateEditCounterpartiesPage,
    beforeEnter: ifAuthenticated,
    name: "edit-counterpartie",
  },
  {
    path: "/projects",
    component: ProjectsPage,
    beforeEnter: ifAuthenticated,
    name: "projects",
  },
  {
    path: "/new-project",
    component: CreateEditProjectsPage,
    beforeEnter: ifAuthenticated,
    name: "create-project",
  },
  {
    path: "/project/:slug",
    component: CreateEditProjectsPage,
    beforeEnter: ifAuthenticated,
    name: "edit-project",
  },
  {
    path: "/events-logs",
    component: EventsPage,
    beforeEnter: ifAuthenticated,
    name: "events",
  },
  {
    path: "/new-event",
    component: CreateEditEventsPage,
    beforeEnter: ifAuthenticated,
    name: "create-event",
  },
  {
    path: "/event/:id",
    component: CreateEditEventsPage,
    beforeEnter: ifAuthenticated,
    name: "edit-event",
  },
];
const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes,
});

export default router;
